export const DEFAULT_WHITELIST = [
  "vk",
  "instagram",
  "facebook",
  "telegram",
  "twitter",
  "youtube",
] as const;
